import Conditions from '@components/Items/Filters/Conditions'
import Locations from '@components/Items/Filters/Locations'
import PickupDates from '@components/Items/Filters/PickupDates'
import EndDates from '@components/Items/Filters/EndDates'
import Categories from '@components/Items/Filters/Categories'
import Msrp from '@components/Items/Filters/MSRP'
import BidftaPlus from '@components/Items/Filters/BidftaPlus'
import PickupDays from '@components/Items/Filters/PickupDays'
import NumberOfUniqueBidders from '@components/Items/Filters/NumberOfUniqueBidders'

const Filters = () => {
  return (
    <div className={'flex flex-col gap-2'}>
      <Locations />
      <Categories />
      <Conditions />
      <Msrp />
      <PickupDates />
      <EndDates />
      <BidftaPlus />
      <PickupDays />
      <NumberOfUniqueBidders />
    </div>
  )
}

export default Filters
